<template>
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.502 3.31983C10.4663 3.11809 8.41832 3.01416 6.37647 3.01416C5.16603 3.01416 3.9556 3.07529 2.74516 3.19756L1.49805 3.31983"
      stroke="#A3B0BA"
      stroke-width="0.933333"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M4.86035 2.70237L4.99484 1.90153C5.09266 1.32076 5.16602 0.886719 6.19917 0.886719H7.80085C8.834 0.886719 8.91348 1.34522 9.00518 1.90764L9.13967 2.70237"
      stroke="#A3B0BA"
      stroke-width="0.933333"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M11.1875 5.25159L10.7901 11.4077C10.7229 12.3675 10.6679 13.1133 8.96225 13.1133H5.0375C3.33189 13.1133 3.27687 12.3675 3.20962 11.4077L2.81226 5.25159"
      stroke="#A3B0BA"
      stroke-width="0.933333"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M5.97913 9.75098H8.01486"
      stroke="#A3B0BA"
      stroke-width="0.933333"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M5.47156 7.30566H8.52821"
      stroke="#A3B0BA"
      stroke-width="0.933333"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>